import {
	UPDATE_FILTER_PRODUCT_VARIANT_INGREDIENT_VARIATION_DEFAULT_REPLACEMENT,
	SET_FILTER_PRODUCT_VARIANT_INGREDIENT_VARIATION_DEFAULT_REPLACEMENT,
	RESET_FILTER_PRODUCT_VARIANT_INGREDIENT_VARIATION_DEFAULT_REPLACEMENT,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './filterProductVariantIngredientVariationDefaultReplacements.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		defaultFilterProductVariantIngredientVariationDefaultReplacement: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				name: '',
				description: '',
				sortOrder: null,
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_FILTER_PRODUCT_VARIANT_INGREDIENT_VARIATION_DEFAULT_REPLACEMENT: {
			return {
				data: {
					defaultFilterProductVariantIngredientVariationDefaultReplacement: payload,
				},
			};
		}

		case UPDATE_FILTER_PRODUCT_VARIANT_INGREDIENT_VARIATION_DEFAULT_REPLACEMENT: {
			return {
				data: {
					defaultFilterProductVariantIngredientVariationDefaultReplacement: {
						...state.data.defaultFilterProductVariantIngredientVariationDefaultReplacement,
						...payload,
					},
				},
			};
		}

		case RESET_FILTER_PRODUCT_VARIANT_INGREDIENT_VARIATION_DEFAULT_REPLACEMENT: {
			return {
				...defaultState,
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchList: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) return payload;
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
